<template>
  <div id="page-trun" v-show="pageLength">
    <div class="page">
      <el-button
        type="text"
        :disabled="page.pageIndex === 1"
        style="padding: 0;"
        @click="pageTrunDown"
      >
        <i class="el-icon-arrow-left"></i>
      </el-button>
    </div>
    <div
      class="page"
      v-show="page.pageIndex > 4 && pageLength > 5"
      @click="pageJump(page.pageIndex - 5)"
    >
      <i class="el-icon-d-arrow-left"></i>
    </div>
    <div
      class="page page-content"
      v-for="i in pages"
      :key="i"
      :class="{ 'this-page': i === page.pageIndex }"
      @click="pageJump(i)"
    >
      {{ i }}
    </div>
    <div
      class="page"
      v-show="page.pageIndex <= pageLength - 3 && pageLength > 5"
      @click="pageJump(page.pageIndex + 5)"
    >
      <i class="el-icon-d-arrow-right"></i>
    </div>
    <div class="page">
      <el-button
        type="text"
        :disabled="!page.hasMore && page.pageIndex >= pageLength"
        style="padding: 0;"
        @click="pageTrunUp"
      >
        <i class="el-icon-arrow-right"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "page-trun",
  props: {
    page: {
      type: Object
    },
    queryData: {
      type: Object | Array
    },
    path: {
      type: String,
      default: ""
    },
    // 分页添加禁用属性，数据请求时可以禁用翻页功能，防止页数超过实际页数
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pageLength() {
      if (Array.isArray(this.queryData)) {
        return this.queryData.length;
      } else {
        if (this.path) {
          // /^(path)_\d$/
          let reg = new RegExp(
            "^" + this.path.replace(/[*/]/g, "\\$&") + "\\d+$"
          );

          let arr = Object.keys(this.queryData).filter(key => reg.test(key));
          return arr.length;
        }
        // console.log("asd", Object.keys(this.queryData), this.queryData);

        return Object.keys(this.queryData).length;
      }
    },
    pages() {
      // 获取总页数列表
      let page = [];
      for (let i = 1; i <= this.pageLength; i++) {
        page.push(i);
      }
      // 页书小于5全部显示，不需要判断
      if (this.pageLength > 5) {
        // 1，2，3页显示前5页
        if (this.page.pageIndex < 4) {
          return page.slice(0, 5);
        }
        // 后续页书不到3页，显示后5页
        if (this.pageLength - this.page.pageIndex < 3) {
          return page.slice(this.pageLength - 5);
        }
        // 正常显示 index +2 -2页
        // slice (] 左开右闭
        return page.slice(this.page.pageIndex - 3, this.page.pageIndex + 2);
      }
      return page;
    }
  },
  methods: {
    pageTrunUp() {
      if (this.disabled) return;
      this.$emit("pageTrun", this.page.pageIndex + 1);
    },
    pageTrunDown() {
      if (this.disabled) return;

      this.$emit("pageTrun", this.page.pageIndex - 1);
    },
    pageJump(index) {
      if (this.disabled) return;
      if (index < 1) {
        index = 1;
      } else if (index > this.pageLength) {
        index = this.pageLength;
      }
      this.$emit("pageTrun", index);
    }
  }
};
</script>

<style lang="scss" scoped>
#page-trun {
  height: 32px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  background: #ffffff;
  .page {
    display: flex;
    height: 27px;
    width: 30px;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    font-size: 13px;
    color: #606266;
    cursor: pointer;
    margin-top: 3px;
    &:first-child {
      border-radius: 4px 0 0 4px;
    }
    &:last-child {
      border-right: 1px solid #ebeef5;
      border-radius: 0 4px 4px 0;
    }
    &:hover,
    &.this-page {
      color: #33a3ff;
    }
    &.page-content {
      width: 40px;
    }
  }
}
</style>
